import domready from 'domready';
import React from 'react';
import Logger from './Logger';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import RoomPlugin from './RoomPlugin';

const logger = new Logger();

// if (isElectron())
// 	Router = HashRouter;
// else
// 	Router = BrowserRouter;

domready(() =>
{
	logger.debug('DOM ready');

	// loadJS([ {
	// 	url : 'https://cdnjs.cloudflare.com/ajax/libs/webrtc-adapter/8.1.2/adapter.js'
	// } ]).then(() =>
	// {
	// eslint-disable-next-line no-console
	run();
	// });
});

async function run()
{
	const container = document.getElementById('_invc');
	const root = createRoot(container);
	root.render(<RoomPlugin/>);
}

serviceWorker.unregister();
